<ndt-department-detail-view
   [department]="department$ | async"
   [departmentPrivileges]="departmentPrivileges$ | async"
   [callState]="callState$ | async"
   [isSystemUser]="isSystemUser$ | async"
   [selectedAccountName]="selectedAccount$ | async"
   (formSaveCanceled)="onFormSaveCanceled()"
   (deleteDepartment)="onDeleteDepartment($event)"
   (deactivateDepartment)="onDeactivateDepartment($event)"
   (formSubmitted)="onFormSubmitted($event)"
   (renameDepartment)="onRenameDepartment($event)"
   (mergeDepartment)="onMergeDepartment($event)"
   (untagDepartment)="onUntagDepartment($event)"
></ndt-department-detail-view>
